import { ArcadeGameProps } from 'Providers';

export const arcadeGames: { [x: string]: ArcadeGameProps } = {
  pitfall: {
    imgSrc: 'https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e8cf7e8b42cd67aad2_pitfall-150x150.png',
    title: 'Pitfall - Mayan Adventure',
    gameSrc: 'https://www.retrogames.cc/embed/24198-pitfall-the-mayan-adventure-europe.html'
  },
  tetris: {
    imgSrc: 'https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e8a54e99b5c7ebd426_Tetris-150x150.png',
    title: 'Tetris',
    gameSrc: "https://www.retrogames.cc/embed/17612-tetris-usa.html"
  },
  wolfenstein: {
    imgSrc: 'https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e8f4ef716eed23cbca_doom-1-150x150.png',
    title: 'Wolfenstein 3D',
    gameSrc: 'https://www.retrogames.cc/embed/22882-wolfenstein-3d-usa.html'
  },
  rayman: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e81c283ed2cc816d4b_rayman-150x150.png",
    title: 'Rayman 2',
    gameSrc: 'https://www.retrogames.cc/embed/41925-rayman-2-the-great-escape.html'
  },
  carmageddon: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc47d49bc1f190aba70bc_41647_55ff9d714754c3f93cfe76f233610434557ee62e-150x150.jpeg",
    title: 'Carmageddon',
    gameSrc: 'https://www.retrogames.cc/embed/41647-carmageddon.html'
  },
  chronotrigger: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc4a6950599d7257e369e_chrono-150x150.png",
    title: 'Chrono Trigger',
    gameSrc: 'https://www.retrogames.cc/embed/22857-chrono-trigger-usa.html'
  },
  duke_nukem_3d: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc4c541ae30ed2df44643_32619_3aba2e805f8fad93896ede2beccecb12d98af982-150x150.png",
    title: 'Duke Nukem 3D',
    gameSrc: 'https://www.retrogames.cc/embed/32786-duke-nukem-64-usa.html'
  },
  bomberman: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc4e35853445cbf20f51f_31735_acb063b939db877c57ff42dcfea79165d07424be-150x150.png",
    title: 'Bomberman',
    gameSrc: 'https://www.retrogames.cc/embed/23880-super-bomberman-3-europe.html'
  },
  mario64: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc50c0929410f638c4bb9_mario64-150x150.png",
    title: 'Super Mario 64',
    gameSrc: 'https://www.retrogames.cc/embed/42182-super-wario-64.html'
  },
  thps: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e74d8daafdc4deabf0_tony1-150x150.png",
    title: 'Tony Hawks Pro Skater',
    gameSrc: 'https://www.retrogames.cc/embed/42152-tony-hawks-pro-skater.html'
  },
  thps2: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e77084bb2e06190ae5_Tony-150x150.png",
    title: 'Tony Hawks Pro Skater 2',
    gameSrc: 'https://www.retrogames.cc/embed/42153-tony-hawks-pro-skater-2.html'
  },
  thps3: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc52de0198a59a25cffa4_tony-3-150x150.png",
    title: 'Tony Hawks Pro Skater 3',
    gameSrc: 'https://www.retrogames.cc/embed/42331-tony-hawks-pro-skater-3.html'
  },
  gta: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc5495c994c758d14eb26_GTA1-150x150.jpeg",
    title: 'Grand Theft Auto',
    gameSrc: 'https://www.retrogames.cc/embed/41827-grand-theft-auto.html.html'
  },
  gta2: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc56b788179e0361053bc_gta2-150x150.jpeg",
    title: 'Grand Theft Auto 2',
    gameSrc: 'https://www.retrogames.cc/embed/41828-grand-theft-auto-2.html'
  },
  pinball: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfcb6493f7b31c7a59a0be_23345_54977cf386d989b54e1b63c4515cdf4cbbb2f9f1-150x150.png",
    title: 'Pinball Fantasies',
    gameSrc: 'https://www.retrogames.cc/embed/24179-pinball-fantasies-europe.html'
  },
  simcity: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc58509bade22f59f8744_simcity-150x150.png",
    title: 'Sim City',
    gameSrc: 'https://www.retrogames.cc/embed/23583-simcity-2000-usa.html'
  },
  crashbandicoot: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc5a0c3bf1f0d5d182f06_40085_538e0e265b3c71590e627609ac798d0d969ba0b4-150x150.png",
    title: 'Crash Bandicoot',
    gameSrc: 'https://www.retrogames.cc/embed/40784-crash-bandicoot.html'
  },
  prince_of_persia: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc5cb41ae303f6ff44711_23986_f9debbe607f95de4edbe9da9115598a1787b5318-150x150.png",
    title: 'Prince of Persia',
    gameSrc: 'https://www.retrogames.cc/embed/24449-prince-of-persia-europe.html'
  },
  goldeneye: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc60cccff1e38401a1e00_007-150x150.png",
    title: '007: Goldeneye',
    gameSrc: 'https://www.retrogames.cc/embed/32471-007-goldeneye-usa.html'
  },
  pacman: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc626c3bf1f10f91833d5_pacman-150x150.png",
    title: 'Pacman',
    gameSrc: 'https://www.retrogames.cc/embed/26817-classic-nes-pacman-u-hyperion.html'
  },
  spiderman: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc643fac5e4ea6c0bd8d6_spiderman-150x150.png",
    title: 'The Amazing Spiderman',
    gameSrc: 'https://www.retrogames.cc/embed/24277-amazing-spider-man-the-lethal-foes-japan.html'
  },
  aladdin: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc65f2be05a3de598812a_aladdin-150x150.png",
    title: 'Aladdin',
    gameSrc: 'https://www.retrogames.cc/embed/17022-aladdin-usa.html'
  },
  marvel_vs_capcom: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc678f40e0c38eb6d4fac_42360_7455651f95c226cf3a6346095d9439f6c4020d95-150x150.png",
    title: 'Marvel vs Capcom',
    gameSrc: 'https://www.retrogames.cc/embed/42360-marvel-vs-capcom-clash-of-super-heroes.html'
  },
  tekken3: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e748b8c928c5b01281_tekken3-150x150.png",
    title: 'Tekken 3',
    gameSrc: 'https://www.retrogames.cc/embed/40238-tekken-3.html'
  },
  doom: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690ea09b62c20018ee233_41575_d0e660998f8053167f493b0064b85726136bb1d4.png",
    title: 'DOOM',
    gameSrc: 'https://www.retrogames.cc/embed/40297-doom-europe.html'
  },
  sonic: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc6989931fc9716c53c28_42536_2088f9b96991543853a9af9fd28fccc09d24ffa3-150x150.png",
    title: 'Sonic The Hedgehog',
    gameSrc: 'https://www.retrogames.cc/embed/30899-sonic-the-hedgehog-usa-europe.html'
  },
  banjo_kazooie: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e77747e106e8aebba0_42578_4ec75ced3f6895279a0de3523e82b76d8e16b212-150x150.png",
    title: 'Banjo Kazooie',
    gameSrc: 'https://www.retrogames.cc/embed/32914-banjo-kazooie-usa.html'
  },
  captain_america: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc6b628dbf4a73df2fdbc_captainamerica-150x150.png",
    title: 'Captain America and the Avengers',
    gameSrc: 'https://www.retrogames.cc/embed/24140-captain-america-and-the-avengers-europe.html'
  },
  castlevania_dracula_X: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e6ef87bdb93595cd6a_castlevania-150x150.png",
    title: 'Castlevania: Dracula X',
    gameSrc: 'https://www.retrogames.cc/embed/23408-castlevania-dracula-x-usa.html'
  },
  chessmaster: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc6d203c572d3313d97d0_chess-150x150.png",
    title: 'The Chessmaster',
    gameSrc: 'https://www.retrogames.cc/embed/22419-chessmaster-the-europe.html'
  },
  dk_country: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc6f2e0198a5a365d1165_donkey-150x150.png",
    title: 'Donkey Kong Country',
    gameSrc: 'https://www.retrogames.cc/embed/23005-donkey-kong-country-usa.html'
  },
  dk_country_3: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc726cbbc7f15fa1db326_donkeykong.png",
    title: 'Donkey Kong Country 3',
    gameSrc: 'https://www.retrogames.cc/embed/23289-donkey-kong-country-3-dixie-kong-s-double-trouble-europe-en-fr-de.html'
  },
  final_fantasy_2: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc74b58534490042113f5_finalfantasy-150x150.png",
    title: 'Final Fantasy 2',
    gameSrc: 'https://www.retrogames.cc/embed/19618-final-fantasy-ii-usa.html'
  },
  frogger: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e6f4ef71914523cbc9_frog-150x150.png",
    title: 'Frogger',
    gameSrc: 'https://www.retrogames.cc/embed/20314-frogger-usa.html'
  },
  harvest_moon: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc7774e1ac4f6867eff55_harvestmoon-150x150.png",
    title: 'Harvest Moon',
    gameSrc: 'https://www.retrogames.cc/embed/24460-harvest-moon-europe.html'
  },
  jungle_book: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc7a0585344bc8f21147e_junglebook.png",
    title: 'The Jungle Book',
    gameSrc: 'https://www.retrogames.cc/embed/24744-jungle-book-the-europe.html'
  },
  kirby_super_star: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc7c85853443fe121149a_kirby-super-star-150x150.png",
    title: 'Kirby Super Star',
    gameSrc: 'https://www.retrogames.cc/embed/24938-kirby-super-star-usa.html'
  },
  the_lion_king: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc7e495059990757e3f45_thelionking-150x150.png",
    title: 'The Lion King',
    gameSrc: 'https://www.retrogames.cc/embed/19874-lion-king-the-usa.html'
  },
  luigis_adventure: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc8037ae68c17cb0fdb02_luigi.png",
    title: 'Luigi\'s Adventure',
    gameSrc: 'https://www.retrogames.cc/embed/42403-luigis-adventure-ose.html'
  },
  mk: {
    imgSrc: "https://i.987967.xyz/screenshot/79/i/24899_ac63361477613f79a07732e0838e9275ba2ee102.png",
    title: 'Mortal Kombat',
    gameSrc: 'https://www.retrogames.cc/embed/24198-pitfall-the-mayan-adventure-europe.html'
  },
  megaman_7: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc8205ed7439b7db8b562_megaman-150x150.png",
    title: 'Megaman VII',
    gameSrc: 'https://www.retrogames.cc/embed/16692-megaman-vii-usa.html'
  },
  power_rangers: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc83a5c994ce74f14f285_powerrangers-150x150.png",
    title: 'Mighty Morphin Power Rangers',
    gameSrc: 'https://www.retrogames.cc/embed/16692-megaman-vii-usa.htmlhttps://www.retrogames.cc/embed/19560-mighty-morphin-power-rangers-the-movie-usa.html'
  },
  fifa_95: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc859f4242a1ad827ea66_fifa95-150x150.png",
    title: 'FIFA Soccer \'95',
    gameSrc: 'https://www.retrogames.cc/embed/29970-fifa-soccer-95-usa-europe-en-fr-de-es.html'
  },
  fifa_96: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc877fac5e456990be68a_fifa-96-150x150.png",
    title: 'FIFA Soccer \'96',
    gameSrc: 'https://www.retrogames.cc/embed/19929-fifa-soccer-96-europe-en-fr-de-es-it-sv.html'
  },
  nineteen_fourty_two: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc896c3bf1fb4ba183ec8_1942-150x150.png",
    title: '1942',
    gameSrc: 'https://www.retrogames.cc/embed/7652-1942-first-version.html'
  },
  dbz_buus_fury: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc8bb714a4a2950e9eb66_dbz1-150x150.png",
    title: 'Dragonball Z: Buu\'s Fury',
    gameSrc: 'https://www.retrogames.cc/embed/26178-2-in-1-dragon-ball-z-buu-s-fury-dragon-ball-gt-transformation-u-independent.html'
  },
  dexters_lab: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc8e136e571091578ec8e_dexter-150x150.png",
    title: 'Dexter\'s Lab - Deesaster Strikes',
    gameSrc: 'https://www.retrogames.cc/embed/26605-dexter-s-laboratory-deesaster-strikes-e-gba.html'
  },
  dbz: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61d690e63a588a3d1bc4293c_dbz-150x150.png",
    title: 'Dragonball Z',
    gameSrc: 'https://www.retrogames.cc/embed/40092-dragon-ball-gt-final-bout.html'
  },
  dbz_gt_final_bout: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc90a03c57237283d9fd4_dbz4-150x150.png",
    title: 'Dragonball Z GT - Final Bout',
    gameSrc: 'https://www.retrogames.cc/embed/40092-dragon-ball-gt-final-bout.html'
  },
  colin_mcrae: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc927bb525b4484287e7b_collin-150x150.jpeg",
    title: 'Colin McRae Rally 2.0',
    gameSrc: 'https://www.retrogames.cc/embed/41669-colin-mcrae-rally-2.html'
  },
  command_conquer: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc94095059986fb7e5671_CC-150x150.jpeg",
    title: 'Command & Conquer Red Alert',
    gameSrc: 'https://www.retrogames.cc/embed/41679-command-conquer-red-alert.html'
  },
  destruction_derby_2: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc95bccff1eb7391a3207_DD2-150x150.jpeg",
    title: 'Destruction Derby 2',
    gameSrc: 'https://www.retrogames.cc/embed/41726-destruction-derby-2.html'
  },
  driver: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc97b36e5710e0e78eff3_driver-150x150.jpeg",
    title: 'Driver',
    gameSrc: 'https://www.retrogames.cc/embed/41743-driver-you-are-the-wheelman.html'
  },
  grantourismo: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc99b7ae68cd6a80fdcf6_granturismo-150x150.jpeg",
    title: 'Gran Turismo',
    gameSrc: 'https://www.retrogames.cc/embed/41826-gran-turismo.html'
  },
  tarzan: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc9b4ee71aa2c3f226c2e_tarzan-150x150.png",
    title: 'Tarzan',
    gameSrc: 'https://www.retrogames.cc/embed/32376-tarzan-europe.html'
  },
  xmen: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc9cefac5e43eec0bee72_xmen-1-150x144.png",
    title: 'X-Men',
    gameSrc: 'https://www.retrogames.cc/embed/31444-x-men-usa-europe.html'
  },
  xmen_mutant_apocalypse: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfc9e715a021783582f5ed_xmen2-150x150.png",
    title: 'X-Men: Mutant Apocalypse',
    gameSrc: 'https://www.retrogames.cc/embed/22926-x-men-mutant-apocalypse-usa.html'
  },
  super_smash_bros: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfca0295059942827e5f92_SSS-150x150.png",
    title: 'Super Smash Bros',
    gameSrc: 'https://www.retrogames.cc/embed/32117-super-smash-bros-usa.html'
  },
  motocross_mania_2: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfca1993f7b3d04f5998a9_motorcross-150x150.png",
    title: 'Motocross Mania 2',
    gameSrc: 'https://www.retrogames.cc/embed/40121-motocross-mania-2.html'
  },
  syphon_filter_3: {
    imgSrc: "https://uploads-ssl.webflow.com/619551a9ec00d55c6c61ff0d/61dfca404e1ac459537f2715_syhon-150x150.png",
    title: 'Syphon Filter 3',
    gameSrc: 'https://www.retrogames.cc/embed/40806-syphon-filter-3.html'
  },
}